import { actionCreatorFactory } from "typescript-fsa";
import {NewMandant} from '../typing/generalType';

const actionCreator = actionCreatorFactory("MandantenInputFactory");

const createClient = actionCreator<{NewMandant:NewMandant}>("MANDANTENINPUT_CREATENEWUSER");
const SetUserDetail = actionCreator<{data:any, type:string}>("MANDANTENINPUT_SETSTARTTIME");
// state update action object
export const actions = {createClient, SetUserDetail};